<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header" :class="{ 'page-header--scrolled': headerScrolled }">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button text="" default-href="/showcase"></ion-back-button>
        </ion-buttons>
        <ion-title>Подписка</ion-title>
        <ion-buttons slot="end">
          <HeaderMessengerButton />
          <ion-button v-if="subscription && isAdmin" @click="$router.push(`/admin-subscriptions/${subscription.id}/edit`)">
            <IonIcon :icon="createOutline" />
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content
      class="main-background events-content subscription-detail-content"
      :fullscreen="true"
      :scroll-y="true"
      @ionScroll="onContentScroll"
    >
      <div v-if="loading" class="ion-padding ion-text-center">Загрузка...</div>
      <div v-else-if="!subscription" class="ion-padding ion-text-center">Подписка не найдена.</div>
      <div v-else class="ion-padding event-detail">
        <img
          :src="subscription.logoPath ? subscriptionsService.logoUrl(subscription.logoPath) : defaultLogoSrc"
          class="event-detail-logo"
          :class="{ 'event-detail-logo--default': !subscription.logoPath }"
          :alt="subscription.title"
        />
        <h1 class="event-detail-title">{{ subscription.title }}</h1>
        <p v-if="subscription.durationDays" class="event-detail-meta">
          Срок действия: {{ subscription.durationDays }} {{ durationLabel(subscription.durationDays) }}
        </p>
        <template v-if="subscription.description">
          <p class="event-detail-desc-label">Описание</p>
          <p class="event-detail-desc">{{ subscription.description }}</p>
        </template>
        <div v-if="subscription.priceTiers?.length" class="event-tiers">
          <p class="tiers-label">Тарифы:</p>
          <ul>
            <li v-for="t in subscription.priceTiers" :key="t.id">{{ t.name }} — {{ (t.amountKopecks / 100).toFixed(0) }} ₽</li>
          </ul>
        </div>

        <template v-if="!myPurchase">
          <ion-item v-if="subscription.priceTiers?.length >= 2" lines="none">
            <ion-select
              label="Тариф"
              cancel-text="Отмена"
              v-model="selectedTierId"
              interface="action-sheet"
              placeholder="Выберите"
            >
              <ion-select-option v-for="t in subscription.priceTiers" :key="t.id" :value="t.id">
                {{ t.name }} — {{ (t.amountKopecks / 100).toFixed(0) }} ₽
              </ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item v-if="requiresPaidPhone" lines="none" class="event-phone-item">
            <ion-input
              v-model="paymentPhone"
              type="tel"
              inputmode="tel"
              autocomplete="tel"
              name="phone"
              label="Телефон"
              label-placement="stacked"
              placeholder="+7 ___ ___-__-__"
              @ionInput="onPaymentPhoneInput"
              @ionBlur="onPaymentPhoneBlur"
            />
          </ion-item>
          <ion-note v-if="requiresPaidPhone" class="event-phone-note">
            Телефон обязателен для оформления подписки и нужен для связи после покупки.
          </ion-note>
          <ion-button expand="block" class="event-register-btn" :disabled="purchasing || phoneRequiredMissing" @click="startPurchase">
            Оформить подписку
          </ion-button>
        </template>

        <template v-else>
          <ion-note class="reg-status">
            <template v-if="myPurchase.refundedAt">Возврат выполнен</template>
            <template v-else-if="myPurchase.active">Подписка активна<template v-if="myPurchase.expiresAt"> до {{ formatDate(myPurchase.expiresAt) }}</template></template>
            <template v-else-if="myPurchase.cancelledAt">
              Отменена<template v-if="myPurchase.paidAt">, ожидается возврат средств</template>
            </template>
            <template v-else-if="!myPurchase.paidAt">Ожидает оплаты</template>
            <template v-else>Не активна</template>
          </ion-note>
          <ion-item
            v-if="!myPurchase.paid && subscription.priceTiers && subscription.priceTiers.length >= 2"
            lines="none"
            class="event-tier-select-item"
          >
            <ion-select
              label="Тариф"
              cancel-text="Отмена"
              v-model="selectedTierIdForPay"
              interface="action-sheet"
              placeholder="Выберите тариф"
            >
              <ion-select-option v-for="t in subscription.priceTiers" :key="t.id" :value="t.id">
                {{ t.name }} — {{ (t.amountKopecks / 100).toFixed(0) }} ₽
              </ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item v-if="showPayButton && requiresPaidPhone" lines="none" class="event-phone-item">
            <ion-input
              v-model="paymentPhone"
              type="tel"
              inputmode="tel"
              autocomplete="tel"
              name="phone"
              label="Телефон"
              label-placement="stacked"
              placeholder="+7 ___ ___-__-__"
              @ionInput="onPaymentPhoneInput"
              @ionBlur="onPaymentPhoneBlur"
            />
          </ion-item>
          <ion-note v-if="showPayButton && requiresPaidPhone" class="event-phone-note">
            Телефон обязателен для оплаты и нужен для связи после покупки.
          </ion-note>
          <ion-button
            v-if="showPayButton"
            expand="block"
            class="event-pay-btn"
            :disabled="paying || phoneRequiredMissing"
            @click="goPay"
          >
            Оплатить {{ (amountToPayKopecks / 100).toFixed(0) }} ₽
          </ion-button>
          <ion-note v-if="!myPurchase.paid" class="offer-note">
            Нажимая «Оплатить», вы соглашаетесь с
            <router-link to="/offer-supplement">договором оферты</router-link>.
          </ion-note>
          <ion-button
            v-if="canCancel"
            expand="block"
            fill="outline"
            color="warning"
            class="event-cancel-btn"
            :disabled="cancelling"
            @click="confirmCancel"
          >
            Отменить подписку
          </ion-button>
        </template>
        <div class="event-detail-bottom-spacer" aria-hidden="true"></div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonNote,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar,
  alertController,
  toastController
} from '@ionic/vue';
import { createOutline } from 'ionicons/icons';
import { computed, defineComponent, inject } from 'vue';
import { useRoute } from 'vue-router';
import type { ILigaSubscription } from '@/model/liga-subscription.model';
import type { ILigaSubscriptionPurchase } from '@/model/liga-subscription-purchase.model';
import { GlobalContext } from '@/model/globalcontext.model';
import subscriptionsService from '@/services/subscriptions.service';
import { formatPhoneDisplay, isValidPhone, phoneForApi } from '@/utils/phone.util';
import logoBlack from '@/theme/liga-logo-black.png';
import logoWhite from '@/theme/liga-logo-white.png';
import dayjs from 'dayjs';

import HeaderMessengerButton from '@/components/HeaderMessengerButton.vue';

export default defineComponent({
  name: 'SubscriptionDetail',
  components: {
    HeaderMessengerButton,
    IonBackButton,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonNote,
    IonPage,
    IonSelect,
    IonSelectOption,
    IonTitle,
    IonToolbar
  },
  setup() {
    const route = useRoute();
    const accountService = inject<{ hasAnyAuthorityAndCheckAuth: (auth: string) => Promise<boolean> }>('accountService');
    const globalContext = inject('globalContext') as GlobalContext;
    const defaultLogoSrc = computed(() =>
      (globalContext.effectiveTheme || 'dark') === 'light' ? logoBlack : logoWhite
    );
    return { route, accountService, globalContext, createOutline, defaultLogoSrc };
  },
  data() {
    return {
      subscription: null as ILigaSubscription | null,
      myPurchase: null as ILigaSubscriptionPurchase | null,
      loading: true,
      purchasing: false,
      paying: false,
      cancelling: false,
      selectedTierId: null as number | null,
      selectedTierIdForPay: null as number | null,
      paymentPhone: '',
      headerScrolled: false,
      isAdmin: false,
      subscriptionsService
    };
  },
  computed: {
    amountToPayKopecks(): number {
      if (!this.myPurchase || !this.subscription?.priceTiers?.length) return 0;
      if (this.myPurchase.amountPaidKopecks != null && this.myPurchase.amountPaidKopecks > 0) {
        return this.myPurchase.amountPaidKopecks;
      }
      const tierId = this.selectedTierIdForPay ?? this.myPurchase.priceTierId;
      if (tierId != null) {
        const tier = this.subscription.priceTiers.find((t) => t.id === tierId);
        if (tier) return tier.amountKopecks;
      }
      if (this.subscription.priceTiers.length === 1) return this.subscription.priceTiers[0].amountKopecks;
      return 0;
    },
    showPayButton(): boolean {
      const p = this.myPurchase;
      if (!p || p.refundedAt || p.cancelledAt || p.paidAt) return false;
      return this.amountToPayKopecks > 0;
    },
    canCancel(): boolean {
      const p = this.myPurchase;
      if (!p || p.refundedAt || p.cancelledAt) return false;
      return true;
    },
    requiresPaidPhone(): boolean {
      return Boolean(this.subscription?.priceTiers?.some((t) => (t.amountKopecks ?? 0) > 0));
    },
    phoneRequiredMissing(): boolean {
      return Boolean(this.requiresPaidPhone && !isValidPhone(this.paymentPhone));
    },
    normalizedPaymentPhone(): string {
      return phoneForApi(this.paymentPhone);
    }
  },
  async mounted() {
    const ok =
      (await this.accountService?.hasAnyAuthorityAndCheckAuth?.('ROLE_ADMIN')) ||
      (await this.accountService?.hasAnyAuthorityAndCheckAuth?.('ROLE_MANAGER')) ||
      false;
    this.isAdmin = ok;
    await this.load();
  },
  ionViewWillEnter() {
    const id = Number(this.route.params.id);
    if (id && this.subscription?.id === id) {
      void this.load(true);
    }
  },
  methods: {
    onContentScroll(e: CustomEvent) {
      this.headerScrolled = (e.detail?.scrollTop ?? 0) > 16;
    },
    pickRelevantPurchase(list: ILigaSubscriptionPurchase[]): ILigaSubscriptionPurchase | null {
      if (!list.length) return null;
      const sorted = [...list].sort((a, b) => (b.purchasedAt || '').localeCompare(a.purchasedAt || ''));
      const active = sorted.find((p) => p.active && !p.refundedAt);
      if (active) return active;
      const pending = sorted.find((p) => !p.paidAt && !p.cancelledAt && !p.refundedAt);
      if (pending) return pending;
      const awaitingRefund = sorted.find((p) => p.paidAt && p.cancelledAt && !p.refundedAt);
      if (awaitingRefund) return awaitingRefund;
      const cancelled = sorted.find((p) => p.cancelledAt && !p.refundedAt);
      if (cancelled) return cancelled;
      return null;
    },
    formatDate(iso: string) {
      return dayjs(iso).format('D MMMM YYYY, HH:mm');
    },
    durationLabel(days: number): string {
      const v = days % 10;
      const v2 = days % 100;
      if (v2 >= 11 && v2 <= 14) return 'дней';
      if (v === 1) return 'день';
      if (v >= 2 && v <= 4) return 'дня';
      return 'дней';
    },
    async load(silent = false) {
      const id = Number(this.route.params.id);
      if (!id) {
        this.loading = false;
        return;
      }
      if (!silent) this.loading = true;
      try {
        this.subscription = await subscriptionsService.getSubscription(id);
        const purchases = await subscriptionsService.getMyPurchases();
        this.myPurchase = this.pickRelevantPurchase(purchases.filter((p) => p.subscriptionId === id));
        if (this.subscription?.priceTiers?.length === 1) {
          this.selectedTierId = this.subscription.priceTiers[0].id;
        }
        if (this.myPurchase?.priceTierId != null) {
          this.selectedTierIdForPay = this.myPurchase.priceTierId;
        }
        if (this.requiresPaidPhone && !isValidPhone(this.paymentPhone)) {
          try {
            const savedPhone = await subscriptionsService.getMyPhone();
            this.paymentPhone = savedPhone ? formatPhoneDisplay(savedPhone) : '';
          } catch {
            this.paymentPhone = '';
          }
        }
      } catch {
        if (!silent) this.subscription = null;
      }
      if (!silent) this.loading = false;
    },
    onPaymentPhoneInput(ev: CustomEvent) {
      const raw = (ev.detail as { value?: string })?.value ?? '';
      if (isValidPhone(raw)) {
        this.paymentPhone = formatPhoneDisplay(raw);
        return;
      }
      this.paymentPhone = raw;
    },
    onPaymentPhoneBlur(ev: CustomEvent) {
      const raw = (ev.detail as { value?: string })?.value ?? this.paymentPhone;
      const formatted = formatPhoneDisplay(raw);
      if (formatted) {
        this.paymentPhone = formatted;
      }
    },
    async startPurchase() {
      if (!this.subscription) return;
      if (this.phoneRequiredMissing) {
        await this.showPaymentErrorToast('Укажите корректный телефон для связи после покупки.');
        return;
      }
      this.purchasing = true;
      try {
        this.myPurchase = await subscriptionsService.purchase(
          this.subscription.id,
          this.selectedTierId ?? undefined,
          this.normalizedPaymentPhone
        );
        if (this.myPurchase.paid) {
          await this.load(true);
        } else if (this.amountToPayKopecks > 0) {
          await this.goPay();
        }
      } catch (e: any) {
        const msg = e?.message || 'Не удалось оформить подписку';
        const toast = await toastController.create({ message: msg, color: 'warning', duration: 4000 });
        await toast.present();
      }
      this.purchasing = false;
    },
    isValidEmail(s: string | null | undefined): boolean {
      if (s == null || typeof s !== 'string') return false;
      const t = s.trim();
      const at = t.indexOf('@');
      return at > 0 && at < t.length - 1 && t.indexOf('.', at + 1) > at + 1;
    },
    async goPay() {
      if (!this.myPurchase) return;
      if (this.phoneRequiredMissing) {
        await this.showPaymentErrorToast('Укажите корректный телефон для связи после покупки.');
        return;
      }
      const userEmail = this.myPurchase.userEmail?.trim();
      if (!this.isValidEmail(userEmail)) {
        const alert = await alertController.create({
          header: 'Email для чека',
          message: 'Укажите электронную почту для чека после оплаты.',
          inputs: [{ name: 'email', type: 'email', placeholder: 'example@mail.ru' }],
          buttons: [
            { text: 'Отмена', role: 'cancel' },
            {
              text: 'Оплатить',
              handler: (data) => {
                const entered = data?.email?.trim();
                if (!this.isValidEmail(entered)) return false;
                void this.doPayment(entered);
                return true;
              }
            }
          ]
        });
        await alert.present();
        return;
      }
      await this.doPayment(userEmail);
    },
    async doPayment(customerEmail?: string) {
      if (!this.myPurchase) return;
      this.paying = true;
      try {
        const tierId = this.selectedTierIdForPay ?? this.myPurchase.priceTierId ?? undefined;
        const { redirectUrl } = await subscriptionsService.createPayment(
          this.myPurchase.id,
          tierId,
          customerEmail,
          this.normalizedPaymentPhone
        );
        if (redirectUrl) {
          if (this.globalContext.isMobile) {
            window.open(redirectUrl, '_system');
          } else {
            window.location.href = redirectUrl;
          }
        }
      } catch (e: any) {
        const data = e?.response?.data ?? e?.data;
        let msg =
          data?.detail ||
          (typeof data?.message === 'string' && !String(data.message).startsWith('error.') ? data.message : null) ||
          e?.message ||
          'Не удалось создать платёж';
        if (
          data?.message === 'error.payment_unavailable' ||
          msg === 'Payment provider unavailable' ||
          e?.message === 'error.payment_unavailable'
        ) {
          msg = 'Оплата временно недоступна. Проверьте настройки ЮKassa (shop-id и ключ) на сервере.';
        } else if (data?.message === 'error.phonerequired' || msg === 'Phone required for paid subscription') {
          msg = 'Укажите корректный телефон для связи после покупки.';
        }
        await this.showPaymentErrorToast(msg);
      }
      this.paying = false;
    },
    async showPaymentErrorToast(msg: string) {
      const toast = await toastController.create({ message: msg, color: 'warning', duration: 4000 });
      await toast.present();
    },
    async confirmCancel() {
      const paidMsg = this.myPurchase?.paid
        ? ' При отмене оплаченной подписки возврат средств выполняется администратором вручную.'
        : '';
      const alert = await alertController.create({
        header: 'Отменить подписку?',
        message: `Вы отмените эту подписку.${paidMsg}`,
        buttons: [
          { text: 'Нет', role: 'cancel' },
          { text: 'Да, отменить', role: 'destructive', handler: () => this.cancelPurchase() }
        ]
      });
      await alert.present();
    },
    async cancelPurchase() {
      if (!this.myPurchase) return;
      this.cancelling = true;
      try {
        await subscriptionsService.cancelPurchase(this.myPurchase.id);
        this.myPurchase = null;
        await this.load(true);
      } catch (e) {
        console.error(e);
      }
      this.cancelling = false;
    }
  }
});
</script>

<style scoped>
.subscription-detail-content {
  --padding-bottom: calc(24px + env(safe-area-inset-bottom));
}

.event-detail {
  padding-bottom: calc(8px + env(safe-area-inset-bottom));
}

.event-detail-bottom-spacer {
  height: calc(128px + env(safe-area-inset-bottom));
  flex-shrink: 0;
  pointer-events: none;
}

.event-detail-logo {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 12px;
  display: block;
  margin: 0 auto 16px;
}
.event-detail-logo--default {
  object-fit: contain;
  background: var(--liga-surface);
  border: 1px solid var(--liga-surface-border);
  padding: 16px;
  box-sizing: border-box;
}
.event-detail-title {
  font-size: 1.5rem;
  margin-bottom: 8px;
  color: var(--liga-chrome-text);
}
.event-detail-meta {
  color: var(--liga-chrome-text);
  margin-bottom: 4px;
}
.event-detail-desc-label {
  font-size: 0.9em;
  font-weight: 600;
  color: var(--liga-chrome-text);
  margin-bottom: 4px;
}
.event-detail-desc {
  white-space: pre-wrap;
  margin-bottom: 16px;
  color: var(--liga-chrome-text);
}
.event-tiers {
  margin-bottom: 16px;
  color: var(--liga-chrome-text);
}
.tiers-label {
  font-weight: 600;
  margin-bottom: 4px;
}
.reg-status {
  display: block;
  margin-bottom: 12px;
  color: var(--liga-chrome-text);
}
.offer-note {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  color: var(--liga-chrome-text);
}
.offer-note a {
  color: var(--ion-color-orange);
}
.event-detail ion-item {
  --background: var(--liga-surface);
  --color: var(--liga-chrome-text);
}
.event-phone-item {
  margin-top: 12px;
  border-radius: 12px;
  overflow: hidden;
  --background: var(--liga-float-glass-bg-strong) !important;
  border: 1px solid var(--liga-surface-border);
  box-shadow: var(--liga-float-glass-shadow, none);
}
.event-phone-item ion-input {
  --background: transparent;
  --color: var(--liga-chrome-text);
  --placeholder-color: var(--liga-chrome-text-muted);
  --highlight-color-focused: var(--ion-color-orange, #ff6600);
  --padding-start: 12px;
  --padding-end: 12px;
}
.event-phone-note {
  display: block;
  margin: 6px 0 10px;
  font-size: 12px;
  color: var(--liga-chrome-text-muted);
}
.event-register-btn,
.event-pay-btn {
  --background: #e85d04;
  --color: var(--liga-on-accent);
  font-weight: 600;
  border-radius: 8px;
  margin-top: 8px;
}
.event-cancel-btn {
  --border-color: rgba(255, 193, 7, 0.8);
  --color: #ffc107;
  margin-top: 20px;
}
</style>
